module.exports = __webpack_public_path__ + "media/img/skorzana@2x-58fa69bb.png";